// @flow
import { createAction } from "redux-act";

export const fetchRounds = createAction("Fetch Rounds");
export const fetchRoundsSuccess = createAction("Fetch Rounds Success");
export const fetchRoundsFailed = createAction("Fetch Rounds Failed");

export const fetchPastRounds = createAction("Fetch Past Rounds");
export const fetchPastRoundsSuccess = createAction("Fetch Past Rounds Success");
export const fetchPastRoundsFailed = createAction("Fetch Past Rounds Failed");